// src/utils/youtube-bg.js
import YouTubePlayer from 'yt-player';

function extractId(url) {
    const m = String(url).match(/(?:youtu\.be\/|v=)([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : url; // allow raw ID
}

export function initYouTubeBackground() {
    const origin =
        window.location.origin ||
        (window.location.protocol + '//' + window.location.host);

    document.querySelectorAll('.ytbg[data-yt-url]').forEach((el) => {
        // Optional zoom to crop baked-in bars
        const zoom = parseFloat(el.dataset.ytZoom || '1');
        if (zoom && zoom !== 1) el.style.setProperty('--yt-zoom', String(zoom));

        const id = extractId(el.dataset.ytUrl);

        // Mount
        const mount = document.createElement('div');
        mount.className = 'ytbg__mount';
        el.appendChild(mount);

        // Create player
        const player = new YouTubePlayer(mount, {
            autoplay: true,
            controls: false,
            related: false,
            playsInline: true,
            annotations: false,
            modestBranding: true,
        });

        // Ensure iframe has ?origin=<site> once it's injected (prevents postMessage warnings)
        const ensureOriginOnIframe = () => {
            const iframe = mount.querySelector('iframe');
            if (!iframe || !iframe.src) return;
            try {
                const u = new URL(iframe.src);
                if (u.searchParams.get('origin') !== origin) {
                    u.searchParams.set('origin', origin);
                    // These enable native looping on YouTube’s side
                    u.searchParams.set('loop', '1');
                    u.searchParams.set('playlist', id);
                    iframe.src = u.toString(); // reloads once with correct origin
                }
            } catch { /* ignore */ }
        };
        const mo = new MutationObserver((muts, obs) => { ensureOriginOnIframe(); obs.disconnect(); });
        mo.observe(mount, { childList: true, subtree: true });

        // Load & autoplay muted
        player.load(id, true);
        player.setVolume(0);
        player.play();

        // Fade-in only when actually playing (hides the YouTube spinner)
        player.on('playing', () => { el.classList.add('is-ready'); });

        // Optional start/end loop
        const start = parseInt(el.dataset.ytStart || '0', 10);
        const end = parseInt(el.dataset.ytEnd || '0', 10);
        if (start || end) {
            // Loop between start/end
            player.on('timeupdate', (t) => {
                if (end && t >= end - 0.05) { player.seek(start || 0); player.play(); }
            });
        } else {
            // Loop whole video
            player.on('ended', () => { player.seek(0); player.play(); });
        }
    });
}
